import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import './index.css';
import reportWebVitals from './reportWebVitals';

import { UserProvider } from './contexts/UserContext';

import FrontRoute from './routes/FrontRoute';
import AdminRoute from './routes/AdminRoute';

const App = () => {
	return (
		<UserProvider>
			<BrowserRouter>
				<Routes>
					{FrontRoute}
					{AdminRoute}
				</Routes>
			</BrowserRouter>
		</UserProvider>
	);
};

ReactDOM.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>,
	document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
